import StudyTaskModel from '@/Models/StudyTaskModel';
import BaseService from '../BaseService';
import {
  StudyTaskResponse,
  StudyTasksResponse
} from './mappers/StudyTaskResponses';

class StudyTaskService extends BaseService {
  /**
   * Get study tasks -- backend
   * @returns {Promise<StudyTaskModel[]>}
   * @memberof StudyTaskService
   */
  getMyGroupStudyTasks() {
    return this.backend('my/group/study-tasks').then(response =>
      StudyTasksResponse(response.data)
    );
  }

  /**
   * Update study tasks -- backend
   * @param {StudyTaskModel[]} studyTasks
   * @returns {Promise<StudyTaskModel[]>}
   * @memberof StudyTaskService
   */
  updateMyGroupStudyTasks(studyTasks) {
    return this.backend('put', 'my/group/study-tasks', studyTasks).then(
      response => StudyTasksResponse(response.data)
    );
  }

  publishMyGroupStudyTasks() {
    return this.backend('post', 'my/group/study-tasks/publish').then(
      response => response.data
    );
  }

  getMyNextStudyTask() {
    return this.backend('my/study-tasks/next').then(response =>
      response.data != null ? StudyTaskResponse(response.data) : null
    );
  }

  getMyStudyTasks() {
    return this.backend('my/study-tasks').then(response =>
      StudyTasksResponse(response.data)
    );
  }
}
export default new StudyTaskService();
